/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'

icon.register({
  'train': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M853.333 202.667H544v-96c0-17.067-14.933-32-32-32s-32 14.933-32 32v96H170.667C130.133 202.667 96 236.8 96 277.333v384C96 701.867 130.133 736 170.667 736H358.4l-87.467 151.467C262.4 902.4 266.667 921.6 281.6 930.133c4.267 2.134 10.667 4.267 14.933 4.267 10.667 0 21.334-6.4 27.734-17.067l106.666-183.466H588.8l106.667 183.466C701.867 928 712.533 934.4 723.2 934.4c6.4 0 10.667-2.133 14.933-4.267 14.934-8.533 21.334-27.733 10.667-42.666L661.333 736h192C893.867 736 928 701.867 928 661.333v-384c0-40.533-34.133-74.666-74.667-74.666zM864 661.333c0 6.4-4.267 10.667-10.667 10.667H170.667c-6.4 0-10.667-4.267-10.667-10.667v-384c0-6.4 4.267-10.666 10.667-10.666h682.666c6.4 0 10.667 4.266 10.667 10.666v384z"/><path pid="1" d="M682.667 501.333H341.333c-17.066 0-32 14.934-32 32s14.934 32 32 32h341.334c17.066 0 32-14.933 32-32s-14.934-32-32-32zm0-128H341.333c-17.066 0-32 14.934-32 32s14.934 32 32 32h341.334c17.066 0 32-14.933 32-32s-14.934-32-32-32z"/>'
  }
})
